import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { ErrorHandlerService } from '../../../shared/services/error-handler.service';
import { API_BASE_URL } from '../../../shared/tokens/api.tokens';
import { Audit } from '../models/audit.model';
import { AuditItem } from '../models/audit-item.model';

@Injectable({
  providedIn: 'root'
})
export class AuditItemService extends ApiService<AuditItem> {

  override searchFields: string[] = [];
  override _baseUrl: string;

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}audits-items/`;    
  }  

  
}
